import { getCookie, setCookie } from 'cookies-next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export function useUTMCapture() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (!router.isReady) {
      return;
    }

    const existingData = getCookie('utmData');
    // console.log('🔍 Existing cookie:', existingData);

    if (existingData) {
      return;
    }

    const { query } = router;

    const utmParams = {
      utm_source: query.utm_source,
      utm_medium: query.utm_medium,
      utm_campaign: query.utm_campaign,
      utm_content: query.utm_content,
      utm_term: query.utm_term,
      promo_code: query.promo_code,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(utmParams).filter(
        ([_, v]) => v !== null && v !== undefined
      )
    );

    if (Object.keys(filteredParams).length > 0) {
      setCookie('utmData', JSON.stringify(filteredParams));
      // console.log('UTM saved to cookie:', filteredParams);
    } else {
      // console.log('No UTM params');
    }
  }, [router.query, router.isReady]);
}
